<div class="py-[60px] md:py-[80px] lg:py-[100px] xl:py-[150px]">
    <div class="container md:max-w-[960px] 2xl:max-w-[1320px] mx-auto px-[12px] relative z-[1]">
        <div class="text-center mx-auto md:max-w-[680px] lg:max-w-[830px]">
            <h2 class="!text-2xl md:!text-4xl lg:!text-[45px] xl:!text-[48px] !mb-[13px] md:!mb-[20px] lg:!mb-[25px] xl:!mb-[35px] -tracking-[.5px] md:-tracking-[.8px] lg:-tracking-[1.2px] xl:-tracking-[1.5px] !leading-[1.2]">
                <!--i18n: Your currency from around the world, delivered with complete confidence. -->
                {{ 'i18n.app.features.pages.front-pages.common.fp-cta.h1_01' | translate }}
            </h2>
            <p class="mx-auto text-gray-400 !leading-[1.6] md:max-w-[650px] lg:max-w-[680px] xl:max-w-[740px] md:text-[15px] lg:text-md xl:text-lg xl:tracking-[.2px]">
                <!-- i18n: Order your currency online securely and pick it up easily at the bpost branch of your choice. Simple, fast and reliable. -->
                 {{ 'i18n.app.features.pages.front-pages.common.fp-cta.p_01' | translate }}
            </p>
            <a 
                [routerLink]="['/order-page']" 
                class="inline-block  lg:text-[15px] xl:text-md mt-[5px] md:mt-[12px] lg:mt-[20px] xl:mt-[25px] py-[12px] px-[17px] mr-[5px] bg-primary-500 text-white rounded-md transition-all font-medium hover:bg-primary-500">
                <span class="inline-block relative ltr:pl-[25px] rtl:pr-[25px] ltr:md:pl-[29px] rtl:md:pr-[29px]">
                    <i class="material-symbols-outlined absolute ltr:left-0 rtl:right-0 top-1/2 -translate-y-1/2 !text-[20px] md:!text-xl">
                        shop
                    </i>
                    <!-- i18n: Order -->
                    {{ 'i18n.app.features.pages.front-pages.common.fp-banner.span_01' | translate }}
                </span>
            </a>
            <!-- <a routerLink="/dashboard" class="inline-block lg:text-[15px] xl:text-md mt-[5px] md:mt-[10px] lg:mt-[20px] xl:mt-[30px] py-[12px] px-[17px] bg-primary-600 text-white rounded-md transition-all font-medium hover:bg-primary-500">
                <span class="inline-block relative ltr:pl-[25px] rtl:pr-[25px] ltr:md:pl-[29px] rtl:md:pr-[29px]">
                    <i class="material-symbols-outlined absolute ltr:left-0 rtl:right-0 top-1/2 -translate-y-1/2 !text-[20px] md:!text-xl">
                        person
                    </i>
                    Get started - It is free
                </span>
            </a> -->
        </div>
        <!-- <div class="absolute ltr:left-[10px] rtl:right-[10px] -top-[200px] -z-[1] blur-[150px]">
            <img src="images/front-pages/shape7.png" alt="shape7">
        </div>
        <div class="absolute ltr:right-[25px] rtl:left-[25px] top-[150px] -z-[1] blur-[125px] hidden md:block">
            <img src="images/front-pages/shape8.png" alt="shape8">
        </div> -->
    </div>
</div>